export default "__VITE_ASSET__E_aQHuQq__"